import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import myTuluCover from "../../images/MyTulu/heroPdf.webp";
import CoverHeader from "./CoverHeaderPDF";
import { TuluUnitExpended } from "./PDF/TuluUnitExpended";
import { SuggestedProductsForRent } from "../MyTulu/ExpendedMyTulu/SuggestedProductsForRent";
import { TuluRideExpended } from "../MyTulu/ExpendedMyTulu/TuluRideExpended";
import { TuluUnitDrawExpended } from "./ExpendedMyTulu/TuluUnitDrawExpended";
import RidePlans from "../CreateUnit_Form/ride/RidePlans";
import Expand from "react-expand-animated";
import { RideRentPrintShop } from "./PDF/ride_rent_print_shop";
import { Costs } from "./costs";
import Farewell from "./FareWell";
import Footer from "./PDF/Footer";
import FaqExpend from "./ExpendedMyTulu/FaqExpend";
import getFirebase from "../../firebase";
import { currencyByLocation } from "./currencyByLocation";
import { useNormalizeItems } from "./useNormalizeItems";
import addItemsCount from "./addSetItemsCount";
import { downloadPDF } from "./downloadPDF";
import usePopulateProposalItems from "../CarpenterView/usePopulateProposalItems.jsx";

const currentDate = new Date()
  .toLocaleDateString()
  .replace(".", "-")
  .replace(".", "-");
const PDFBrochure = ({ data, setPDFMode, setLink }) => {
  const [colorUnit, setColorUnit] = useState();
  const [buildingName, setBuildingName] = useState("");
  const [itemsCount, setItemsCount] = useState({});
  const [columns, setColumns] = useState();
  const [rideColumnItems, setRideColumnItems] = useState();
  const [rentItems, setRentItems] = useState();
  const [shopItems, setShopItems] = useState();
  const [rideItems, setRideItems] = useState();
  const [logoImage, setLogoImage] = useState(null);
  const [roomSimulationImage, setRoomSimulationImage] = useState(null);
  const [rideSimulationImage, setRideSimulationImage] = useState(null);

  const [location, setLocation] = useState("us");
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [numOfUnit, setNumOfUnit] = useState("");
  const [setupFee, setSetupFee] = useState("");
  const [setupFeeBeforeDiscount, setSetupFeeBeforeDiscount] = useState("");
  const [serviceFee, setServiceFee] = useState("");
  const [serviceFeeBeforeDiscount, setServiceFeeBeforeDiscount] = useState("");
  const isCM = location !== "us";
  let pageNumber = 1;

  useEffect(() => {
    getFirebase();
    if (!data) return;
    setRoomSimulationImage(data.roomSimulationImage);
    setRideSimulationImage(data.rideSimulationImage);
    setBuildingName(data.buildingName);
    setNumOfUnit(data.numOfUnit);
    setColorUnit(data.colorUnit);
    setSetupFee(data.setupFee);
    setSetupFeeBeforeDiscount(data.setupFeeBeforeDiscount);
    setServiceFee(data.serviceFee);
    setServiceFeeBeforeDiscount(data.serviceFeeBeforeDiscount);
    setLocation(data.location);
    setLogoImage(data.logoImage);
    currencySymbolByLocation(data.location);
    let newColumns = JSON.parse(data.columns);
    let ride = JSON.parse(data.rideItems);

    setColumns(newColumns);

    if (ride && ride.length > 0 && ride[0] && data.ride) {
      setRideColumnItems(ride);
    }

    if (newColumns) {
      addSetItemsCount({ ride, newColumns });
    }
    // Initialization keyed on `data`; addSetItemsCount/currencySymbolByLocation are
    // behavior-stable wrappers recreated each render, so adding them would re-run every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const currencySymbolByLocation = currencyByLocation(setCurrencySymbol);

  useEffect(() => {
    function isEverythingLoaded() {
      if (rideItems && rentItems && shopItems) {
        return (
          Object.keys(rideItems).length > 0 ||
          Object.keys(rentItems).length > 0 ||
          Object.keys(shopItems).length > 0
        );
      }
    }
    if (isEverythingLoaded()) {
      downloadPDF(buildingName, setPDFMode, setLink);
    }
  }, [rideItems, rentItems, shopItems, buildingName, setPDFMode, setLink]);

  useNormalizeItems(
    itemsCount,
    location,
    setShopItems,
    setRideItems,
    setRentItems
  );

  const addSetItemsCount = addItemsCount(setItemsCount);

  const pageUp = () => {
    pageNumber++;
    return pageNumber;
  };

  const _renderExpendTitle = (
    bool,
    setBool,
    title,
    expend,
    showUpperDivider
  ) => {
    return (
      <>
        <div
          style={{
            fontSize: 40,
            fontWeight: 800,
            fontFamily: "Lexend",
            textTransform: "uppercase",
            flex: 1,
            marginLeft: 96,
          }}
        >
          {title}
        </div>
        <Expand open={bool}>{expend}</Expand>
        <div
          style={{
            margin: "0 100px",
          }}
        />
      </>
    );
  };

  const ExpendedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    /* height: 1080px;
    width: 1920px; */
  `;

  const [rentPages, setRentPages] = React.useState([]);
  const [purchasePages, setPurchasePages] = React.useState([]);

  usePopulateProposalItems(
    rentItems,
    rideItems,
    shopItems,
    setPurchasePages,
    setRentPages
  );

  const pdfexport = React.useRef();
  return (
    <Wrapper id="pdfexport" ref={pdfexport}>
      <PDFPage className="pdfPage" style={{ paddingTop: 0 }}>
        <CoverHeader
          img={myTuluCover}
          title={"Give Your Building\nthe Goods"}
          subtitle={
            "TULU provides on-demand access to the day-\nto-day things residents want and need, from\nhome essentials to printers and scooters — \nand beyond."
          }
        />
      </PDFPage>

      <PDFPage className="pdfPage">
        <Pager>
          {" "}
          {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
        </Pager>
        <Footer />
        <RideRentPrintShop />
      </PDFPage>
      {/*<PhysicalAndDigital />*/}
      {columns && (
        //units page
        <>
          <PDFPage className="pdfPage">
            <Pager>
              {" "}
              {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
            </Pager>
            <Footer />
            <ExpendedWrapper>
              <TuluUnitExpended
                colorUnit={colorUnit}
                logoImage={logoImage}
                columns={columns}
                itemsCount={itemsCount}
                buildingName={buildingName}
                location={location}
                headLine={"TULU UNIT"}
              />
            </ExpendedWrapper>
          </PDFPage>
          <>
            {" "}
            <PDFPage className="pdfPage">
              <Pager>
                {" "}
                {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
              </Pager>

              <Footer />

              <div
                style={{
                  position: `absolute`,
                  left: 99,
                  bottom: 137,
                  fontSize: 19,
                  fontFamily: `DMsans`,
                }}
              >
                All dimensions are {isCM ? "In CM" : "In inches"}
              </div>

              <ExpendedWrapper>
                <TextWrapper style={{ fontSize: 40 }}>
                  {buildingName}
                </TextWrapper>
                <TextWrapper style={{ fontSize: 50 }}>UNIT PLAN</TextWrapper>

                <TuluUnitDrawExpended
                  isPDF={true}
                  colorUnit={colorUnit}
                  rideItems={rideColumnItems}
                  logoImage={null}
                  columns={columns}
                  itemsCount={itemsCount}
                  location={location}
                  isCarpenter={false}
                />
              </ExpendedWrapper>
            </PDFPage>
          </>
          {rideColumnItems && (
            <PDFPage className="pdfPage">
              <Pager>
                {" "}
                {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
              </Pager>
              <Footer />
              <TuluRideExpended
                buildingName={buildingName}
                isPDF={true}
                colorUnit={colorUnit}
                rideColumnItems={rideColumnItems}
                itemsCount={itemsCount}
              />
            </PDFPage>
          )}

          {rideColumnItems && (
            <>
              <RidePlans
                buildingName={buildingName}
                type="scooter"
                //setUnitScale={setRideUnitScale}
                rideItems={rideColumnItems?.filter(
                  (item) => item.type === "scooter"
                )}
                location={location}
                pageUp={pageUp()}
                isPDF={true}
              />

              <RidePlans
                buildingName={buildingName}
                pageUp={pageUp()}
                isPDF={true}
                type="bicycle"
                //setUnitScale={setRideUnitScale}
                rideItems={rideColumnItems?.filter(
                  (item) => item.type === "bicycle"
                )}
                location={location}
              />
            </>
          )}

          {roomSimulationImage && (
            <PDFPage className="pdfPage">
              <Footer />
              <Pager>
                {" "}
                {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
              </Pager>{" "}
              <TextWrapper style={{ fontSize: 40 }}>
                {" "}
                {buildingName}
              </TextWrapper>
              <TextWrapper style={{ fontSize: 50 }}>
                YOUR <br /> BUILDING <br /> YOUR <br /> TULU
              </TextWrapper>
              <ImageWrapper style={{ marginTop: 75 }}>
                <Img id="simImage" src={roomSimulationImage} alt="simulation" />
              </ImageWrapper>
            </PDFPage>
          )}
          {rideSimulationImage && (
            <PDFPage className="pdfPage">
              <Footer />
              <Pager>
                {" "}
                {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
              </Pager>{" "}
              <TextWrapper style={{ fontSize: 40 }}>
                {" "}
                {buildingName}
              </TextWrapper>
              <TextWrapper style={{ fontSize: 50 }}>
                YOUR <br /> BUILDING <br /> YOUR <br /> TULU
              </TextWrapper>
              {rideColumnItems && rideSimulationImage && (
                <ImageWrapper style={{ marginTop: 75 }}>
                  <Img id="simImage" src={rideSimulationImage} />
                </ImageWrapper>
              )}
            </PDFPage>
          )}

          {rentPages.map((page, index) => {
            const firstPage = index === 0;
            return (
              <PDFPage key={Object.keys(page)[0]} className="pdfPage">
                <Pager>
                  {" "}
                  {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
                </Pager>

                <Footer />
                <ExpendedWrapper>
                  {_renderExpendTitle(
                    true,
                    null,
                    firstPage ? "Suggested Products For Rent" : "",
                    <SuggestedProductsForRent
                      location={location}
                      items={page}
                      isPDF={true}
                    />,
                    !roomSimulationImage
                  )}
                </ExpendedWrapper>
              </PDFPage>
            );
          })}
          {purchasePages.map((page, index) => {
            const firstPage = index === 0;
            return (
              <PDFPage
                key={Object.keys(page)[0]}
                className="pdfPage"
                style={{ backgroundColor: "white" }}
              >
                <Pager>
                  {" "}
                  {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
                </Pager>

                <Footer />
                {_renderExpendTitle(
                  true,
                  null,
                  firstPage ? "Suggested Products For Purchase" : "",

                  <SuggestedProductsForRent
                    isShop={true}
                    location={location}
                    isPDF={true}
                    items={page}
                    setItems={setShopItems}
                  />
                )}
              </PDFPage>
            );
          })}
        </>
      )}

      <PDFPage className="pdfPage" style={{ backgroundColor: "white" }}>
        <Pager>
          {" "}
          {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
        </Pager>

        <Footer />
        <Costs
          ownerRevenue={data?.ownerRevenue}
          isPDF={true}
          currencySymbol={currencySymbol}
          numOfUnit={numOfUnit}
          setupFeeBeforeDiscount={setupFeeBeforeDiscount}
          setupFee={setupFee}
          serviceFeeBeforeDiscount={serviceFeeBeforeDiscount}
          serviceFee={serviceFee}
          buildingName={buildingName}
        />
      </PDFPage>

      <PDFPage className="pdfPage">
        <Pager>
          {" "}
          {<span style={spanBorder}>{currentDate}</span>} {pageUp()}
        </Pager>

        <Footer />
        <FaqExpend isPDF={true} />
        {/* <RequirementsPage /> */}
      </PDFPage>

      <PDFPage className="pdfPage">
        <Farewell />
      </PDFPage>
    </Wrapper>
  );
};

export { PDFBrochure };

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const PDFPage = styled.div`
  height: 1230px;
  width: 1920px;
  padding-top: 168px;
  position: relative;
`;

const ImageWrapper = styled.div`
  height: 1900px;
  margin: 0 auto;
  padding: 10px 100px;
  font-size: 25px;
  font-family: DMSans, serif;
  position: absolute;
  top: 0px;
  right: 0px;
`;

const Img = styled.img`
  max-width: none;
  height: 900px;
  display: flex;
  margin: 86px auto auto;
`;

const TextWrapper = styled.div`
  font-size: 40px;
  font-weight: bold;
  font-family: "Lexend", serif;
  text-align: left;
  margin-left: 97px;
`;

const Pager = styled.div`
  position: absolute;
  bottom: 28px;
  right: 80px;
  font-size: 22px;
`;

const spanBorder = { marginRight: 10 };
